// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1wU3n","employeesFormsContainer":"styles_employeesFormsContainer__1gG5V","buttonContainer":"styles_buttonContainer__2PWKa"};